<template>
  <v-app id="example-2" toolbar footer>
    <!-- This is the left menu -->
    <v-navigation-drawer
      fixed
      persistent
      light
      :mini-variant.sync="mini"
      v-model="drawer"
      overflow
      v-if="authorized()"
      style="z-index: 5"
    >
      <!-- User bar -->
      <v-toolbar flat class="transparent">
        <v-list class="pa-0">
          <v-list-tile avatar tag="div">
            <v-list-tile-avatar @click="$router.push('/profile')">
              <!--<img src="https://randomuser.me/api/portraits/men/10.jpg" />-->
              <v-icon>account_circle</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title @click="$router.push('/profile')">{{ $store.auth.user.name }} {{ $store.auth.user.surname }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon @click.native.stop="mini = !mini">
                <v-icon>chevron_left</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-toolbar>

      <!-- Custom company logo -->
      <div class="company-logo" v-if="$store.auth.user.company && $store.auth.user.company.customLogo">
        <img :src="$store.auth.user.company.customLogo" />
      </div>

      <!-- Actual menu -->
      <navigation ref="navigation" />

      <!-- Delegations -->
      <delegations v-if="$auth.hasRole('GROUP_ADMIN')" @change="delegationChanged" />
    </v-navigation-drawer>

    <!-- This is the top toolbar -->
    <v-toolbar fixed class="indigo darken-4" dark  v-if="authorized()">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>{{ title() }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!--<v-btn icon v-for="(tool, index) in tools.list" :key="tool.icon" @click="tool.click">
        <v-icon>{{ tool.icon }}</v-icon>
      </v-btn>-->
    </v-toolbar>

    <!-- This is the content -->
    <main>
      <v-container fluid style="padding-bottom: 45px">
        <router-view />
      </v-container>
    </main>

    <v-footer fixed class="footer elevation-5" v-if="authorized()">
      <v-spacer />
      <key-foot />
      <v-flex>Powered by Triinfo Solutions s.r.o.</v-flex>
    </v-footer>
  </v-app>
</template>

<script>
import Navigation from '@/components/Navigation'
import KeyFoot from '@/components/KeyFoot'
import Delegations from '@/components/Delegations'

import Local from '@/store/local'
import { EventBus } from '@/utils/Global'

export default {
  name: 'app',
  data () {
    return {
      drawer: true,
      mini: false,
      right: null,
      idleTimeout: null,
      idleTicks: 0
    }
  },
  created () {
    window.addEventListener('beforeunload', () => this.unload())
    window.addEventListener('load', () => this.resetIdle())

    let idleEvents = ['load', 'mousemove', 'mousedown', 'touchstart', 'click', 'scroll', 'keypress']
    idleEvents.forEach(event => {
      document.addEventListener(event, () => this.resetIdle())
    })

    EventBus.$on('auth-failed', () => {
      this.$auth.clear()
      this.$router.push('/login')
    })

    this.resetIdle()
  },
  methods: {
    unload () {
      if (this.$store.auth.user) {
        require('@/models/User').default.logout()
      }
    },
    resetIdle () {
      clearTimeout(this.idleTimeout)
      this.idleTicks = 0
      this.startIdle()
    },
    startIdle () {
      this.idleTimeout = setTimeout(() => this.timeout(), 5 * 60 * 1000)
    },
    timeout () {
      // Clear saved pass if saved
      let stored = Local.get('private')
      if (stored && stored.pass) {
        stored.pass = null
        this.$store.player.passSaved = false
        Local.set('private', stored)
      } else {
        this.$store.player.passSaved = false
      }

      // Save minutes of being idle
      this.idleTicks++

      // Logout when 4*5=20 minutes passed
      if (this.idleTicks === 4 && this.$store.auth.user) {
        this.$store.login.redirect = this.$route.fullPath
        this.$router.push('/logout')
      }

      // Continue tracking idle time
      this.startIdle()
    },
    title () {
      let matched = this.$router.currentRoute.matched.find(record => record.meta.title)
      return matched && this.$t(matched.meta.title)
    },
    authorized () {
      return this.$auth.isAuthorized()
    },
    delegationChanged () {
      this.$refs.navigation.refresh()
    }
  },
  components: {
    Navigation,
    KeyFoot,
    Delegations
  }
}
</script>

<style>
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

footer {
  text-align: right;
  font-size: 80%;
  z-index: 0;
}

.company-logo {
  margin: 10px 0px;
}

.company-logo img {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// App.vue?2ea0e026